import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AngularModule, MaterialModule } from '@shared/modules';

@Component({
  selector: 'app-input-cuit-cuil',
  standalone: true,
  imports: [AngularModule, MaterialModule],
  templateUrl: './input-cuit-cuil.component.html',
  styleUrl: './input-cuit-cuil.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputCuitCuilComponent {
  readOnly = input<boolean>(false);
  label = input<string>('');
  control = input<FormControl>(new FormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(11), Validators.pattern(/^\d+$/)]));

  isClear = input<boolean>(true);

  // Usar 'output' con una función que emite el evento en lugar de EventEmitter directamente
  clearInput = output<void>();

  clear(): void {
    this.control().setValue('');
    // Emitir el evento utilizando el método emit de clearInput
    this.clearInput.emit();
  }

  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const key = event.key;

    if (this.isControlKey(key)) {
      return;
    }

    if (!this.isNumber(key)) {
      event.preventDefault();
      return;
    }

    if (input.value.length >= 11) {
      event.preventDefault();
    }
  }

  onInputChange(): void {
    const currentValue = this.control().value;
    if (currentValue && currentValue.length > 11) {
      this.control().setValue(currentValue.slice(0, 11));
    }
  }

  private isNumber(key: string): boolean {
    return /^\d$/.test(key);
  }

  private isControlKey(key: string): boolean {
    return ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Tab'].includes(key);
  }
}
